import _get from 'lodash/get';
import AppleIcon from './images/apple.svg';
import GoogleIcon from './images/google.svg';
import AmazonIcon from './images/amazon.svg';
import CMIcon from './images/cm.svg';
import GoodReadsIcon from './images/goodreads.svg';
import YoutubeIcon from './images/youtube.svg';

export const constructUserReviewsData = reviews => {
  const data = [];
  Object.keys(reviews).forEach(key => {
    _get(reviews, [key, 'default'], []).forEach(el => {
      data.push({
        ...el,
        type: key,
      });
    });
  });
  return data;
};

export const getIcon = type => {
  const iconMapping = {
    apple: AppleIcon,
    google: GoogleIcon,
    amazon: AmazonIcon,
    cm: CMIcon,
    goodreads: GoodReadsIcon,
    youtube: YoutubeIcon,
  };

  return iconMapping[type];
};
